import api from './api';

const AUTH_KEY = 'investor_qa_authenticated';

const authService = {
  async authenticate(password) {
    try {
      const response = await api.post('/authenticate', { password });
      if (response.data.authenticated) {
        localStorage.setItem(AUTH_KEY, 'true');
        return true;
      }
      return false;
    } catch (error) {
      console.error('Authentication request failed:', error);
      throw error;
    }
  },

  isAuthenticated() {
    // Password checking disabled
    return true;
    // return localStorage.getItem(AUTH_KEY) === 'true';
  },

  logout() {
    localStorage.removeItem(AUTH_KEY);
  }
};

export default authService;